module.exports = __webpack_public_path__ + "img/MDM.d5a6f552.svg";